/**
 * AI 画图页的对话状态 (仅内存, 切换页面不丢; 刷新即清空, 与旧版一致)。
 */
import { create } from "zustand";
import type { ImageMsg } from "./flow";

interface ImageChatState {
  msgs: ImageMsg[];
  pending: boolean;
  add: (msg: Omit<ImageMsg, "id">) => string;
  replace: (id: string, msg: Omit<ImageMsg, "id">) => void;
  setPending: (p: boolean) => void;
  clear: () => void;
}

let seq = 0;
const nextId = () => `img_${Date.now()}_${++seq}`;

export const useImageChatStore = create<ImageChatState>((set) => ({
  msgs: [],
  pending: false,
  add: (msg) => {
    const id = nextId();
    set((s) => ({ msgs: [...s.msgs, { ...msg, id }] }));
    return id;
  },
  replace: (id, msg) =>
    set((s) => ({ msgs: s.msgs.map((m) => (m.id === id ? { ...msg, id } : m)) })),
  setPending: (pending) => set({ pending }),
  clear: () => set({ msgs: [], pending: false }),
}));
